import { Link, useParams } from "react-router-dom";
import { TactikSiteTopBar } from "../app/TactikSiteTopBar";
import {
  STANDALONE_LEGAL_BODY,
  STANDALONE_LEGAL_TITLES,
  isStandaloneLegalSlug,
} from "./standaloneLegalContent";
import "./StandaloneLegalDocPage.css";

/** Tactik 独立站法规页 */
export default function StandaloneLegalDocPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const known = isStandaloneLegalSlug(slug);
  const title = known ? STANDALONE_LEGAL_TITLES[slug] : "文档";
  const body = known ? STANDALONE_LEGAL_BODY[slug] : "文档不存在。";

  return (
    <div className="standalone-legal-layout">
      <TactikSiteTopBar />
      <div className="standalone-legal-page">
        <p className="standalone-legal-back">
          <Link to="/">返回首页</Link>
        </p>
        <h1 className="standalone-legal-h1">{title}</h1>
        <p className="standalone-legal-p">{body}</p>
      </div>
    </div>
  );
}
